import React from 'react';
import { connect } from 'react-redux';
import { ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestRotatorCuffTearCluster extends React.Component {

    render() {
        return(
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Rotator Cuff Tear Cluster'/>
                <span className={styles.spacer} />
                <label className={styles.label}>SpecialTestRotatorCuffTearCluster</label>
                <span className={styles.r} />
                <span className={styles.c}>Controls</span>
                <span className={styles.l} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TS) {
        flagged = true;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged
    };
}

const connectedSpecialTestRotatorCuffTearCluster = connect(mapStateToProps)(SpecialTestRotatorCuffTearCluster);
export { connectedSpecialTestRotatorCuffTearCluster as SpecialTestRotatorCuffTearCluster };



